import type { OnlineAction } from "./game-store";

function targetGridSlot(action: OnlineAction): number | null {
  if (action.type === "MOVE_ITEM") return action.toSlot;
  if (action.type === "REMOVE_ITEM") return action.slot;
  return null;
}

export class OnlineActionTracker {
  private queued: OnlineAction[] = [];
  private inFlight = new Map<number, OnlineAction>();

  canSchedule(action: OnlineAction): boolean {
    const target = targetGridSlot(action);
    if (target === null) return true;
    return !this.queued.some((candidate) => targetGridSlot(candidate) === target)
      && ![...this.inFlight.values()].some((candidate) => targetGridSlot(candidate) === target);
  }

  enqueue(action: OnlineAction): boolean {
    if (!this.canSchedule(action)) return false;
    this.queued.push(action);
    return true;
  }

  drain(): OnlineAction[] {
    return this.queued.splice(0);
  }

  track(sequence: number, action: OnlineAction): void {
    this.inFlight.set(sequence, action);
  }

  resolve(sequence: number): OnlineAction | undefined {
    const action = this.inFlight.get(sequence);
    this.inFlight.delete(sequence);
    return action;
  }

  clear(): void {
    this.queued = [];
    this.inFlight.clear();
  }

  get queuedCount(): number {
    return this.queued.length;
  }
}
